import React from "react";
import IconcsCard, { IconcsCardProps } from "./IconcsCard";

interface IconsGridProps {
  title: string;
  description: string;
  events: IconcsCardProps[];
}

const IconsGrid: React.FC<IconsGridProps> = ({ title, description, events }) => {
  return (
    <div className="max-w-4xl p-6 mx-auto">
      <h2 className="mb-4 text-xl font-extrabold text-center text-gray-800 md:text-3xl dark:text-white">
        {title}
      </h2>
      <p className="mb-6 text-sm text-center text-gray-600 dark:text-white">{description}</p>
      <div className="grid justify-center grid-cols-2 gap-4 mx-auto md:grid-cols-6">
        {events.map((event, index) => (
          <IconcsCard key={index} icon={event.icon} label={event.label} />
        ))}
      </div>
    </div>
  );
};

export default IconsGrid;
